import * as React from 'react'
import { Block } from 'baseui/block';
import { IVirtualCounter } from './types'
import { FormControl } from "baseui/form-control";
import { Select, Value } from "baseui/select";

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { CounterType } from '../CounterType';
import { FormattedMessage } from 'react-intl';
import { Parameters } from '../BaseCounter/Parameters';


export const ConfigurationPanel = (props: IVirtualCounter) => {

    const dimPower = props.dimension === 'kWh' ? 'kW' : props.dimension === 'MWh' ? 'kW' : props.dimension === 'm³' ? 'l' : '[]'

    return (
        <>
            <Block gridRowGap='20px' display='flex' flexDirection='column' >
                <Parameters {...props}></Parameters>
                <CounterCountTypeSelect {...props}></CounterCountTypeSelect>

            </Block>
        </>
    )
}

const CounterCountTypeSelect = (props: IVirtualCounter) => {
    // counter type
    const [value, setValue] = useSetObjectValue(props.id, props.resourceGroupId, "counts", props.counts);
    const [selected, setSelected] = React.useState<Value>([{ id: value, label: <FormattedMessage id={`CounterType.${CounterType[value]}`} defaultMessage={`${CounterType[value]}`} /> }]);
    const handleChanged = (e: any) => {
        setSelected(e.value);
        setValue(e.value[0].id);
    }
    const types = Object.keys(CounterType).filter((item) => {
        return isNaN(Number(item));
    });
    const options = types.map((item: any, index: number) => { return { label: <FormattedMessage id={`CounterType.${item}`} defaultMessage={`${item}`} />, id: index } });

    return (
        <FormControl
            label={<FormattedMessage id="Devices.CounterTypeCounted" defaultMessage="Counter Type to be counted" />}
            caption={<FormattedMessage id="Devices.TextCounterTypeCounted" defaultMessage="Specify the counter type to be counted" />}
        >
            <Select
                options={options}
                value={selected}
                required
                multi={false}
                searchable={false}
                clearable={false}
                labelKey="label"
                valueKey="id"
                onChange={handleChanged}
            />

        </FormControl>
    )

}


